import { TransformBoolean } from '../../../decorators/transform-boolean.decorator';
import { TransformFloat } from '../../../decorators/transform-float.decorator';
import { TransformInt } from '../../../decorators/transform-int.decorator';
import { TaxRateTypeEnum } from '../../../enums/tax-rate-type.enum';
import { PricingItemTypeEnum } from '../enums/pricing-item-type.enum';

// NOTE: The entity behind this DTO is effectively an owned entity, and is not used outside
// of the context of a parent entity. For this reason, it is not necessary to have a separate
// List or Record versions of it or extend it from the BaseDto.

/**
 * Pricing item DTO
 */
export class PricingItemDto {
  @TransformInt()
  id?: number;
  uuid!: string;
  description?: string | null;
  type!: PricingItemTypeEnum;
  taxRateType!: TaxRateTypeEnum;
  @TransformBoolean()
  isTaxIncluded!: boolean;
  @TransformBoolean()
  isCommissionEligible!: boolean;
  @TransformBoolean()
  isStandardDiscountApplied?: boolean;
  @TransformFloat()
  units!: number;
  @TransformFloat()
  unitPrice!: number;
  @TransformFloat()
  unitTaxRate!: number;
  @TransformFloat()
  unitsTotalNet!: number;
  @TransformFloat()
  unitsTotalTax!: number;
  @TransformFloat()
  unitsTotalGross!: number;
  @TransformFloat()
  unitCommissionRate!: number;
  @TransformFloat()
  unitsTotalCommissionNet!: number;
  @TransformInt()
  pricingItemPresetId?: number | null;
  pricingItemPresetUuid?: string | null;
}
